import { ApiResponse, ConversationResponse } from "../../interfaces/genericResponse/GenericResponse";
import { CreateTeamRequest } from "../../interfaces/identity/Region";
import { CreateCustomGroupRequest, CreateCustomGroupResponse, GetChannelRes, UpdateCustomChannelReq } from "../../interfaces/team/TeamandRegion.modal";

export async function CreateTeamAsync(
    authToken: string,
    payload: CreateTeamRequest
): Promise<ApiResponse<string>> {
    try {
        const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/TeamandRegion/CreateTeam`;

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
        });

        const responseBody = await response.json();
        return responseBody;
    } catch (error) {
        throw error;
    }
}

export async function GetAllChannelAsync(
    authToken: string,
): Promise<ApiResponse<GetChannelRes[]>> {
    try {
        const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/TeamandRegion/GetAllChannel`;

        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            },
        });

        const responseBody = await response.json();
        console.log('Channels, ', responseBody)
        return responseBody;
    } catch (error) {
        throw error;
    }
}


export async function CreateCustomGroupAsync(
    authToken: string,
    payload: CreateCustomGroupRequest
): Promise<ApiResponse<CreateCustomGroupResponse>> {
    try {
        const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/TeamandRegion/createCustomChannel`;

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
        });

        const responseBody = await response.json();
        return responseBody;
    } catch (error) {
        throw error;
    }
}


export async function UpdateCustomGroupAsync(
    authToken: string,
    payload: UpdateCustomChannelReq
): Promise<ApiResponse<ConversationResponse>> {
    try {
        const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/TeamandRegion/UpdateCustomChannel`;

        const response = await fetch(apiUrl, {
            method: "PATCH",
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
        });

        const responseBody = await response.json();
        return responseBody;
    } catch (error) {
        throw error;
    }
}
export async function UpdateTeamAsync(
    authToken: string,
    teamId: number,
    payload: CreateTeamRequest
): Promise<ApiResponse<string>> {
    try {
        const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/TeamandRegion/${teamId}/name`;

        const response = await fetch(apiUrl, {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            },
            // No need to send data in JSON form. Send the teamName directly as string eg: "ABC team"
            body: JSON.stringify(payload?.teamName)
        });

        const responseBody = await response.json();
        return responseBody;
    } catch (error) {
        throw error;
    }
}

export async function DeleteTeamAsync(
    authToken: string,
    teamId: number
): Promise<ApiResponse<boolean>> {
    try {
        const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/TeamandRegion/${teamId}`;

        const response = await fetch(apiUrl, {
            method: "DELETE",
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            },
        });

        // Check if response has content before parsing JSON
        const text = await response.text();

        // If response is empty or status is 204, return success response
        if (!text || response.status === 204) {
            return {
                success: true,
                statusCode: response.status || 200,
                message: "Team deleted successfully",
                data: true
            };
        }

        // Parse JSON only if there's content
        const responseBody = JSON.parse(text);
        return responseBody;
    } catch (error) {
        throw error;
    }
}